import React from "react";
import { useSelector } from "react-redux";
import { selectAllP2pSettings } from "../../../../../redux/slices/p2pSettingsSlice";
import { selectAllRegistration } from "../../../../../redux/slices/registrationSlice";
import { selectIsCms } from "../../../../../redux/slices/configSlice";
import { selectAllClassifications } from "../../../../../redux/slices/classificationsSlice";
import ParticipantList from "./ParticipantList";

const ConnectedParticipantList = () => {
    const isCms = useSelector(selectIsCms);
    const classifications = useSelector(selectAllClassifications);
    const { enableClassifications } = useSelector(selectAllP2pSettings);
    const {
        classification: { Classification = [] },
        registrations = [],
    } = useSelector(selectAllRegistration);

    const validRegistrations = registrations.filter(
        (registration) => Object.keys(registration).length > 0,
    );
    const hasValidRegistration = validRegistrations.length > 0;

    const hasValidClassification =
        enableClassifications && classifications.length > 0
            ? !!(Classification[0] && Classification[0].length > 0)
            : true;

    const displayDivider = !!(
        hasValidClassification &&
        hasValidRegistration &&
        registrations.length > 0
    );

    const displayParticipantCounter =
        hasValidClassification && hasValidRegistration;

    const participantListProps = {
        displayDivider,
        displayParticipantCounter,
        registrations,
        isCms,
        renderRegistration: () => {},
    };

    return <ParticipantList {...participantListProps} />;
};

export default ConnectedParticipantList;
